import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptPennsylvania = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Pennsylvania Non-Profit State Filing Requirements & Deadlines"
          description="Learn Pennsylvania’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state."
          keywords=" "
          canonical="nonprofit-taxes/pennsylvania-state-filing-requirements/"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-pa-landing-img.webp" />
                <source srcSet="/assets/images/state-pa-landing-img.png" />
                <img
                  src="/assets/images/state-pa-landing-img.png"
                  alt="Pennsylvania State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Pennsylvania State </span>
                </span>{' '}
                Filing Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Understanding and meeting the state requirements is essential
                for all nonprofits operating within Pennsylvania.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=pennsylvania`}
                  >
                    Get Started
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-pa-landing-img-sm.webp" />
                <source srcSet="/assets/images/state-pa-landing-img-sm.png" />
                <img
                  src="/assets/images/state-pa-landing-img-sm.png"
                  alt="Pennsylvania State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Pennsylvania nonprofits must be familiar with several critical
            forms, each serving specific compliance purposes:
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of State Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of Revenue Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/dos/programs/business/forms/offsite-forms/15-5306_7102-Art-of-Inc-Dom-Nonprofit.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Articles of Incorporation – Nonprofit
                                (DSCB:15-5306/7102)
                              </Link>
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/dos/resources/business/forms/15-134A%20Docketing%20statement%20creation.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                New Entity Docketing Statement (DSCB:15-134A)
                              </Link>
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/dos/programs/charities/Registration-Statement-BCO-10.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form BCO-10 - Charitable Organization
                                Registration Statement
                              </Link>
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/dos/programs/charities/BCO-2-nonrerewal.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form BCO-2 - Non-Renewal of Charitable
                                Organization Registration Statement
                              </Link>
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/dos/programs/charities/BCO-9-approval-of-exemption-exclusion.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                BCO-9 - Request for Approval of
                                Exemption/Exclusion
                              </Link>
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/dos/programs/charities/bco23.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form BCO-23 - Pennsylvania Public Disclosure
                                Form
                              </Link>
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/revenue/documents/formsandpublications/formsforbusinesses/sut/documents/rev-72.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Form REV-72, Application For Sales Tax Exemption
                              </Link>
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/revenue/documents/formsandpublications/formsforbusinesses/corporationtax/documents/2024/2024_rct-101.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                PA Corporate Net Income Tax Report (RCT-101)
                              </Link>
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://www.pa.gov/content/dam/copapwp-pagov/en/dli/documents/uc/uc-forms/sect%2014.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                PA-100 (Pennsylvania Enterprise Registration
                                Form)
                              </Link>
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              Form 1023 (Application for Recognition of
                              Exemption Under Section 501(c)(3) of the Internal
                              Revenue Code): For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 16 }}>
                              Form 1024 (Application for Recognition of
                              Exemption Under Section 501(a) or Section 521 of
                              the Internal Revenue Code): For other types of
                              nonprofits.
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 990 (Return of Organization Exempt From
                                Income Tax)
                              </Link>
                              : Annual information return for tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                To maintain good standing in Pennsylvania, non-profits must
                complete initial registration, annual reporting, and, if
                applicable, charitable solicitation registration.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Failure to comply may result in fines or loss of operating
                rights.
              </Typography>
              <Box
                component="ol"
                sx={{ mb: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  <span style={{ fontWeight: 600 }}>
                    Forming the Non-Profit:
                  </span>{' '}
                  File Articles of Incorporation – Nonprofit with the PA
                  Department of State to legally establish the organization.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>EIN:</span> Obtain an
                  Employer Identification Number from the IRS for banking,
                  hiring, and tax-exempt applications.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Charitable Solicitation (BCO-10):
                  </span>{' '}
                  File the Charitable Organization Registration Statement if
                  soliciting donations in PA.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Annual Report (2025 onward):
                  </span>{' '}
                  Beginning January 1, 2025, non-profits must file a new Annual
                  Report each year, replacing the old decennial filing.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Sales Tax Exemption (optional):
                  </span>{' '}
                  Eligible 501(c)(3) groups may apply through PA’s myPATH
                  system.
                </li>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-pa-img.webp" />
                <source srcSet="/assets/images/who-file-pa-img.png" />
                <img
                  src="/assets/images/who-file-pa-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{ px: 3, py: 5, borderRadius: 5, maxWidth: 900 }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{ textAlign: 'center' }}
                  >
                    While forming a non-profit provides a legal structure, it
                    doesn&apos;t automatically grant tax-exempt status. To gain
                    exemption from federal and state taxes, you must meet
                    specific requirements
                    <Box
                      component="ul"
                      sx={{
                        listStyleType: 'none',
                        paddingLeft: 0,
                        textAlign: 'left',
                        ml: { xs: 0, sm: 3 },
                        '& li': {
                          // float: 'left',
                          fontSize: 16,
                          display: 'flex',
                        },
                      }}
                    >
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                        />
                        <Box>
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Federal Tax Exemption:
                          </span>{' '}
                          Apply to the IRS for 501(c)(3) status by filing Form
                          1023, Application for Recognition of Exemption Under
                          Section 501(c)(3) of the Internal Revenue Code.
                          Smaller non-profits may be eligible to file Form
                          1023-EZ.
                        </Box>
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                        />
                        <Box>
                          {' '}
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            State Sales Tax Exemption:
                          </span>{' '}
                          You must apply for a separate sales tax exemption from
                          the Pennsylvania Department of Revenue by submitting
                          Form REV-72. Along with the application, organizations
                          are required to include a copy of their IRS Form 990
                          or year-end treasurer&apos;s report, as well as a copy
                          of their bylaws or article of incorporation and
                          dissolution statement.
                        </Box>
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1, mt: -0.2 }}
                        />
                        <Box>
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Property Tax Exemption:
                          </span>{' '}
                          For non-profits that own real property in Pennsylvania
                          and wish to claim exemption from property taxes, the
                          requirements are governed by the{' '}
                          <span
                            style={{ fontWeight: 600, fontStyle: 'italic' }}
                          >
                            {' '}
                            Institutions of Purely Public Charity Act
                          </span>{' '}
                          (10 P.S. § 371 et seq.). Organizations that receive or
                          claim this exemption are required to file an annual
                          report and a copy of their IRS Form 990 with the
                          Department of State.
                        </Box>
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <Box>
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Financial Documentation Requirements:
                          </span>{' '}
                          Organizations must provide articles of incorporation
                          with specific language prohibiting private inurement,
                          current financial statements, IRS determination
                          letters, and recent Form 990 filings.
                        </Box>
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <Box>
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Unrelated Business Income Tax (UBIT):
                          </span>{' '}
                          If your non-profit earns significant income ($1000+
                          gross) from activities unrelated to its exempt
                          purpose, it must file federal Form 990-T and
                          potentially PA Form RCT-101 (if PA taxable UBTI
                          exceeds $100).
                        </Box>
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in
                Pennsylvania:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of State Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Nonprofit (DSCB:15-5306/7102) nitial filing, no
                          specific deadline but typically filed after formation
                          steps and before operations
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Charitable Organization Registration Statement
                          (BCO-10) - Initial
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Before soliciting contributions OR within 30 days of
                          receiving &gt;$25,000 in gross contributions (if no
                          compensated solicitors).
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Charitable Organization Registration Statement
                          (BCO-10) - Annual Renewal
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          5th day of the 11th month after the close of the
                          organization&apos;s fiscal year.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of Revenue Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Application for Sales Tax Exemption (REV-72) Renewal
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Every 5 years for continued exemption
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          PA Corporate Tax Report (RCT-101)
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          If required (due to UBTI), the deadline is generally
                          the 15th day of the 4th month following the close of
                          the fiscal year (e.g., April 15 for calendar year
                          filers). Extensions are available.
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          PA Sales/Use Tax Exemption (myPATH portal)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          No fixed annual deadline; apply when eligible
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=pennsylvania`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a non-profit in Pennsylvania, organizations
            must file
            <Hidden smDown>
              <br />
            </Hidden>{' '}
            the{' '}
            <span style={{ fontWeight: 600 }}>Articles of Incorporation</span>{' '}
            with the Secretary of the State and pay the $125 filing fee.
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      <b>Define Your Mission and Choose a Name </b> Draft
                      articles and bylaws that support your charitable mission
                      and IRS filing. Use SOS instructions for nonprofit
                      articles.
                    </li>
                    <li>
                      <b>Form a Board of Directors and Create Bylaws </b> Form a
                      board of directors to oversee the organization, ensure it
                      fulfills its mission, and maintain financial health. In
                      Pennsylvania, directors must be at least 18, serve
                      one-year terms, and be elected annually. Create bylaws,
                      required by both the IRS for tax-exempt status and the
                      state for incorporation.
                    </li>
                    <li>
                      <b>Publish Notice of Intent to Incorporate </b>
                      As highlighted earlier, Pennsylvania requires publication
                      of your intent to file or the actual filing of Articles of
                      Incorporation in two newspapers of general circulation,
                      one of which must be a legal journal.
                    </li>
                    <li>
                      <b>
                        File Articles of Incorporation and Docketing
                        Statement{' '}
                      </b>{' '}
                      Submit your{' '}
                      <span style={{ fontStyle: 'italic' }}>
                        {' '}
                        Articles of Incorporation – Nonprofit along with the New
                        Entity Docketing Statement
                      </span>{' '}
                      to the Pennsylvania Department of State. The filing fee
                      for the Articles of Incorporation is $125. Online filing
                      is an available option.
                    </li>
                    <li>
                      <b> Register for Charitable Solicitation (BCO-10)</b>{' '}
                      Complete and submit the Form BCO-10 to the PA Department
                      of State. This form requires several attachments,
                      including your IRS Form 990 (or BCO-23 for smaller
                      organizations), financial statements (as applicable), a
                      list of officers and directors, and any professional
                      fundraising contracts.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      <b>
                        Annual Charitable Organization Registration Renewal
                        (BCO-10){' '}
                      </b>{' '}
                      The BCO-10 is not a one-time filing; it requires annual
                      renewal. The renewal is due by the 15th day of the 11th
                      month following the close of the organization&apos;s
                      fiscal year. For example, an organization with a December
                      31st fiscal year end would have a renewal deadline of
                      November 15th. The same BCO-10 form is utilized for this
                      annual renewal.
                    </li>

                    <li>
                      <b>
                        The New Pennsylvania Annual Report (Effective 2025){' '}
                      </b>
                      A significant development in Pennsylvania&apos;s
                      compliance landscape is the introduction of a new Annual
                      Report requirement, effective January 1, 2025. This new
                      annual filing replaces the previous decennial (every 10
                      years) report requirement for nearly all business and
                      non-profit associations registered in Pennsylvania.
                    </li>

                    <li>
                      <b>Combined Registrations </b> Parent organizations can
                      file combined registrations covering Pennsylvania
                      affiliates, with fees based on combined gross
                      contributions.
                    </li>
                    <li>
                      <b>Maintain Compliance with IRS </b>
                      File the annual Form 990 series (990, 990-EZ, 990-N, or
                      990-PF) with the IRS. Failure to do so for three
                      consecutive years can result in automatic revocation of
                      federal tax-exempt status.
                    </li>
                    <li>
                      <b> Keep Corporate Records </b> Pennsylvania nonprofit
                      corporations are legally required to maintain accurate and
                      up-to-date corporate records in accordance with the
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Pennsylvania Nonprofit Corporation Law
                      </span>
                      .
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Dependable Online Filing Platform
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone simplifies nonprofit IRS reporting with compliant filing
          services.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=pennsylvania`}
          >
            E-File Now!
          </Button>
        </Box> */}
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. How do I obtain Pennsylvania sales tax exemption?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Submit Form REV-72 to the Pennsylvania Department of
                      Revenue with supporting documentation including articles
                      of incorporation with required language, financial
                      statements, IRS determination letter, and recent Form 990.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Can parent organizations file for their Pennsylvania
                  affiliates?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Yes, Pennsylvania-based parent organizations can file
                      combined registrations covering their affiliates. Each
                      affiliate must still file a separate BCO-10 form and
                      provide required documentation, but affiliates covered by
                      combined registrations doesn’t need to pay separate
                      registration fees.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Is Pennsylvania corporate net income tax exemption
                  automatic with 501(c)(3) status?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      Yes, upon obtaining your IRS Determination Letter
                      confirming federal 501(c)(3) status, your organization is
                      automatically exempt from Pennsylvania corporate income
                      tax. No separate application is needed for this specific
                      exemption.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What information is required on the annual report?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Box component="ul" sx={{ '& li': { mb: 1.2 } }}>
                      <li>
                        The following information is required on the annual
                        report:{' '}
                      </li>
                      <li>Business name </li>
                      <li>Jurisdiction of formation </li>
                      <li>Registered office address </li>
                      <li>
                        Name of at least one governor (director, general
                        partner, LLC manager or LLC member with material
                        management responsibility, etc. depending on type of
                        association){' '}
                      </li>
                      <li>
                        Names and titles of the principal officers, if any{' '}
                      </li>
                      <li>Address of the principal office </li>
                      <li>
                        Entity number issued by the Pennsylvania Department of
                        State{' '}
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Who can sign the annual report on behalf of the
                  association?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Annual reports must be “signed by the entity or
                      association” (15 Pa.C.S. § 146(a)). The Department of
                      State does not examine a document to determine whether the
                      document has been signed by an authorized person or by
                      sufficient authorized persons or otherwise is duly signed.
                      15 Pa.C.S. § 135(a)(7).
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://www.pa.gov/agencies/dos/programs/charities"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Pennsylvania Department of State - Bureau of
                          Charitable Organizations (BCO)
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://www.pa.gov/agencies/dos/programs/business/types-of-filings-and-registrations/pennsylvania-nonprofit-corporations"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Pennsylvania Nonprofit Corporations
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.pa.gov/agencies/revenue"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Pennsylvania Department of Revenue
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://pano.org/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Pennsylvania Association of Nonprofit Organizations
                          (PANO)
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/charities-non-profits/charitable-organizations/pennsylvania"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Pennsylvania - Charities and Non-profits
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Internal Revenue Services
                        </Link>
                      </li>{' '}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptPennsylvania;
